module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-regular-web.ttf?4ec113919a4e0066f221b8591c3650d4";